import React from "react";
import { FormControl, Box, Flex, FormErrorMessage, FormLabel, Input } from "@chakra-ui/react";
const Address = ({ options, formik }) => {
	const styleClasses = options.styleClasses.length ? options.styleClasses.join(" ") : "";
	const { addressLine1, addressLine2, state, city, zipCode, country } = options.fields;

	const isInvalid = (fieldName) => {
		return (
			formik.touched &&
			formik.touched.address &&
			formik.touched.address[fieldName] &&
			formik.errors &&
			formik.errors.address &&
			formik.errors.address[fieldName]
		);
	};

	return (
		<Box className={styleClasses}>
			{addressLine1.showField && (
				<FormControl
					isInvalid={isInvalid("addressLine1")}
					isRequired={addressLine1.isRequired}
					w="100%"
					mb="3"
				>
					{options.showLabel && <FormLabel fontSize="14px">{addressLine1.label}</FormLabel>}
					<Input
						name="address.addressLine1"
						value={formik.values.address.addressLine1}
						size="sm"
						type="text"
						onChange={formik.handleChange}
						onBlur={formik.handleBlur}
						placeholder={addressLine1.placeholder}
					/>
					{isInvalid("addressLine1") ? (
						<FormErrorMessage>{formik.errors.address.addressLine1}</FormErrorMessage>
					) : null}
				</FormControl>
			)}
			{addressLine2.showField && (
				<FormControl
					isInvalid={isInvalid("addressLine2")}
					isRequired={addressLine2.isRequired}
					w="100%"
					mb="3"
				>
					{options.showLabel && <FormLabel fontSize="14px">{addressLine2.label}</FormLabel>}
					<Input
						name="address.addressLine2"
						value={formik.values.address.addressLine2}
						size="sm"
						type="text"
						onChange={formik.handleChange}
						onBlur={formik.handleBlur}
						placeholder={addressLine2.placeholder}
					/>
					{isInvalid("addressLine2") ? (
						<FormErrorMessage>{formik.errors.address.addressLine2}</FormErrorMessage>
					) : null}
				</FormControl>
			)}
			<Flex justify="space-between" align="center" w="100%" mb="3">
				{city.showField && (
					<FormControl isInvalid={isInvalid("city")} isRequired={city.isRequired}>
						{options.showLabel && <FormLabel fontSize="14px">{city.label}</FormLabel>}
						<Input
							name="address.city"
							value={formik.values.address.city}
							size="sm"
							type="text"
							onChange={formik.handleChange}
							onBlur={formik.handleBlur}
							placeholder={city.placeholder}
						/>
						{isInvalid("city") ? (
							<FormErrorMessage>{formik.errors.address.city}</FormErrorMessage>
						) : null}
					</FormControl>
				)}
				{state.showField && (
					<FormControl isInvalid={isInvalid("state")} isRequired={state.isRequired} ml="3">
						{options.showLabel && <FormLabel fontSize="14px">{state.label}</FormLabel>}
						<Input
							name="address.state"
							value={formik.values.address.state}
							size="sm"
							type="text"
							onChange={formik.handleChange}
							onBlur={formik.handleBlur}
							placeholder={state.placeholder}
						/>
						{isInvalid("state") ? (
							<FormErrorMessage>{formik.errors.address.state}</FormErrorMessage>
						) : null}
					</FormControl>
				)}
			</Flex>
			<Flex justify="space-between" align="center" w="100%">
				{zipCode.showField && (
					<FormControl isInvalid={isInvalid("zipCode")} isRequired={zipCode.isRequired}>
						{options.showLabel && <FormLabel fontSize="14px">{zipCode.label}</FormLabel>}
						<Input
							size="sm"
							name="address.zipCode"
							value={formik.values.address.zipCode}
							type="text"
							onChange={formik.handleChange}
							onBlur={formik.handleBlur}
							placeholder={zipCode.placeholder}
						/>
						{isInvalid("zipCode") ? (
							<FormErrorMessage>{formik.errors.address.zipCode}</FormErrorMessage>
						) : null}
					</FormControl>
				)}
				{country.showField && (
					<FormControl isInvalid={isInvalid("country")} isRequired={country.isRequired} ml="3">
						{options.showLabel && <FormLabel fontSize="14px">{country.label}</FormLabel>}
						<Input
							size="sm"
							name="address.country"
							value={formik.values.address.country}
							type="text"
							onChange={formik.handleChange}
							onBlur={formik.handleBlur}
							placeholder={country.placeholder}
						/>
						{isInvalid("country") ? (
							<FormErrorMessage>{formik.errors.address.country}</FormErrorMessage>
						) : null}
					</FormControl>
				)}
			</Flex>
		</Box>
	);
};

export default Address;
